import React from "react";

export default function ErrorMessage() {
  return (
    <div>
      <div className="text-red-600 mt-20 font-bold w-1/3 mx-auto">
        We cant find your user info in SalesForce, You must signup using your
        work email address associated with your salesforce account.
      </div>
    </div>
  );
}


